import { EditableField } from '@nemuru-eng/js-api-client';

import { AutomobileFormFieldName } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/types/AutomobileFormFieldName';

const EDITABLE_FIELD_TO_FORM_FIELD: Partial<Record<EditableField, AutomobileFormFieldName>> = {
  [EditableField.BRAND]: 'brand',
  [EditableField.MODEL]: 'model',
  [EditableField.VERSION]: 'version',
  [EditableField.YEAR]: 'registrationDate',
  [EditableField.REGISTRATION_DATE]: 'registrationDate',
  [EditableField.VIN]: 'identificationNumber',
  [EditableField.PLATE_NUMBER]: 'plateNumber',
  [EditableField.ODOMETER]: 'odometer',
  [EditableField.VEHICLE_AMOUNT]: 'price',
};

export const hasEditableFields = (editableFields: EditableField[] | undefined): boolean =>
  (editableFields?.length ?? 0) > 0;

export const doesEditableFieldExistInArray = (editableFields: EditableField[], field: EditableField): boolean =>
  editableFields.includes(field);

export const createIsFieldDisabled =
  (editableFields: EditableField[]) =>
  (fieldName: AutomobileFormFieldName): boolean => {
    const editableFormFields = [
      ...new Set(
        editableFields
          .map((editableField) => EDITABLE_FIELD_TO_FORM_FIELD[editableField])
          .filter((formFieldName): formFieldName is AutomobileFormFieldName => !!formFieldName),
      ),
    ];

    return !editableFormFields.includes(fieldName);
  };
